import React, { useState } from "react";
import { useTranslation } from "react-i18next";

const Information = () => {
  const { t } = useTranslation();

  return (
    <>
      <section className="information-section">
        <div className="first-para">
          <h2>
            CHAINERS: THE GAME THAT MAKES YOUR TIME WORTH SOMETHING <span></span>
          </h2>
          <p>Play. Build. Earn. Own your world.</p>
          <p>Chainers is a multi-genre Web3 gaming universe where every quest, battle, and creation builds real value. It’s not a promise – it’s already live: <span style={{ fontWeight: "700" }}>600K+ players, 1M+ daily blockchain transactions, and $600K+ in-game sales</span> before token launch.</p>
          <p>Now, the next step begins – <span style={{ fontWeight: "700" }}>$CHU</span>, the governance and ecosystem token powering the Chainers economy.</p>
          <p>By joining the sale, you’re not just buying a token – you’re claiming a piece of a living gaming world that grows with every player.</p>
          <p>Why Players and Investors want $CHU:</p>
          <ol>
            <li><span>Real utility</span> – access to premium content, events, staking, and in-game rewards.</li>
            <li><span>Proven traction</span> – 90K+ MAU and explosive ARPPU growth ($7 → $40).</li>
            <li><span>Fair launch</span> – only ~10% of tokens circulating at TGE, ensuring low inflation and sustainable growth.</li>
            <li><span>Immutable + Polygon-powered</span> – seamless onboarding for Web2 users with real on-chain ownership.</li>
            <li><span>Multi-game potential</span> – $CHU fuels a growing universe, from farming and building to PvP and UGC creation.</li>
          </ol>
          <p>This isn’t just another gaming token – it’s the currency of a fun-first, earn-based universe built for mass adoption.</p>
          <p>Own your time. Own your world. Own $CHU.</p>
        </div>
        <div className="first-para">
          <h2>
            WHY CHAINERS STANDS OUT <span></span>
          </h2>
          <p><span style={{ fontWeight: "700" }}>Fun-first gameplay. Real ownership. Effortless onboarding.</span></p>
          <p>Chainers removes every barrier that stops players and investors from joining the Web3 revolution.</p>
          <p>It’s built for everyone: Web2 gamers, creators, and crypto natives who want to play, earn, and own – without friction.</p>
          <h6>What Makes Chainers Unique</h6>
          <ol className="rain-list">
            <li>
              <span>Instant onboarding</span> – no wallet needed to start, no installs, no crypto barriers. Just click, play, and earn.
            </li>
            <li>
              <span>Fun-first gameplay</span> – story-driven worlds, PvP battles, farming, and building – not “earn-to-click” loops.
            </li>
            <li>
              <span>Browser-based and scalable</span> – runs on any device; powered by Immutable.
            </li>
            <li>
              <span>Real rewards that matter</span> – every NFT or $CHU token earned has in-game and marketplace value.
            </li>
            <li><span>Evolving economy</span> – built for longevity, with $CHU as the bridge between games, creators, and players.</li>
          </ol>
          <p>Chainers is more than a game – it’s a playable Web3 economy that rewards every minute of engagement.</p>
          <p>The earlier you join, the bigger your share in the world’s fastest-growing gaming universe.</p>
        </div>
        <div className="first-para">
          <h2>
            GO-TO-MARKET STRATEGY <span></span>
          </h2>
          <p><span style={{ fontWeight: "700" }}>Scaling from millions of players to a global tokenized ecosystem.</span></p>
          <p>Chainers’ GTM is built around one goal – to make $CHU one of the most visible and desirable gaming tokens in Web3.</p>
          <p>Our multi-stage launch moves from organic traction to full-scale global expansion:</p>
          <ul>
            <li><span>Soft Launch (Summer 2025)</span> – KOL campaigns, Zealy events, and guild onboarding across SEA, LATAM to grow an early user base and build excitement before token sales.</li>
            <li> <span>Immutable Audience Builder (Fall 2025)</span> –
              Performance ads, referral systems, and token whitelist promotion in collaboration with <span>Immutable, Gam3s.gg, top Guilds, and gaming communities</span>.</li>
            <li><span>Token Sale Expansion (Winter 2025 – Spring 2026)</span> –
              Scaling influencer activations, paid media ads, organic social media campaigns (with streaming platforms), game nights with guilds, and quest platforms to onboard new players.</li>
            <li><span>TGE & Exchange Listing (Mid–Late 2026)</span> –
              Global marketing blitz: 1000+ KOLs, performance ads with worldwide coverage, viral YouTube/TikTok/Kick campaigns, CEX/DEX listings, and PR coverage to solidify $CHU’s market position.</li>
          </ul>
          <p>With partnerships across <span style={{fontWeight: "700"}}>Immutable, Gam3s.gg, GEMS, BGA, Magic Square, and other industry leaders,</span> Chainers is poised to turn real gameplay traction into worldwide token demand.</p>
        </div>
        <div className="first-para">
          <h2>
            Roadmap <span></span>
          </h2>
          <p>The roadmap represents Chainers’ evolution from early gameplay testing to full ecosystem expansion and token launch.</p>
          <h6>2025 – Q1 / Q2 (Season 1)</h6>
          <ul>
            <li>Games Hub • Arena Shooter public test • Daily rewards</li>
            <li>Chainers Dreams mini-game • Character customization • Reward pool upgrade</li>
          </ul>
          <h6>2025 – Q3 / Q4 (Season 2)</h6>
          <ul>
            <li>Token Community Sale • Road to Treasure Event • BNB Withdrawals</li>
            <li>Immutable Passport & Play Quests • Farm Expansion • Winter Sale</li>
            <li>New Quest Integrations • Wheel of Fortune</li>
          </ul>
          <h6>2026 – Q1 / Q2 (Season 3)</h6>
          <ul>
            <li>Public Sale • PvP Arena • Race Event • New Pets & Plants</li>
            <li>New Reward Pools / Tokens • Immutable Infrastructure Expansion</li>
            <li>NFT Cosmetics Upgrade • Mini-game • Referral System Update</li>
            <li>Seasonal Events • Friends Farm Visiting</li>
          </ul>
          <h6>2026 – Q3 / Q4 (Season 5)</h6>
          <ul>
            <li>Token Release / CEX Launch • Loot Boxes • Clans & Teams</li>
            <li>Marketplace • Interactive Map • Seasonal Events</li>
            <li>Subscription Model • Mini-game • Burning Event</li>
          </ul>
          <h6>TOKENOMICS <span></span></h6>

          <p>Built for sustainable growth - designed with long-term ecosystem health in mind.</p>
        </div>
        <div className="first-para">
          <div className="twice-tokenomics">
            {
              window.innerWidth < 600 ?
                <div className="tokenomic-img">
                  <img src="\assets\alldetailpages\chainers\info\chainers-graphmbl.png" alt="img" className='img-fluid hide-in-light-theme' />
                  <img src="\assets\alldetailpages\chainers\info\chainers-graphlightmbl.png" alt="img" className='img-fluid d-none show-in-light-theme ' />
                </div>
                :
                <div className="tokenomic-img">
                  <img src="\assets\alldetailpages\chainers\info\chainers-graph.png" alt="img" className='img-fluid hide-in-light-theme' />
                  <img src="\assets\alldetailpages\chainers\info\chainers-graphlight.png" alt="img" className='img-fluid d-none show-in-light-theme ' />
                </div>
            }
          </div>
        </div>
        <div className="first-para">
          <h2>
            {t('Inc-detailt34')} <span></span>
          </h2>
          <div className="team-gems">
            <div className="single-team">
              <img
                src="\assets\alldetailpages\chainers\info\team\1.png"
                alt="img"
                className="img-fluid"
              />
              <h6 className="mb-0">Matvii Diadkov </h6>
              <h5>Founder (Bitmedia Labs)</h5>
            </div>
            <div className="single-team">
              <img
                src="\assets\alldetailpages\chainers\info\team\ivan.png"
                alt="img"
                className="img-fluid"
              />
              <h6 className="mb-0">Ivan DZHULAI </h6>
              <h5>CEO (Hypercell Games, Nexters)</h5>
            </div>
            <div className="single-team">
              <img
                src="\assets\alldetailpages\chainers\info\team\2.png"
                alt="img"
                className="img-fluid"
              />
              <h6 className="mb-0">Roman Pinskyi </h6>
              <h5>CMO (Mythical Games, DMarket)</h5>

            </div>
            <div className="single-team">
              <img
                src="\assets\alldetailpages\chainers\info\team\3.png"
                alt="img"
                className="img-fluid"
                style={{ objectPosition: "50%" }}
              />
              <h6 className="mb-0">Antonina Malyhina </h6>
              <h5>Producer (Arkadium, Playgendary)</h5>
            </div>
            <div className="single-team">
              <img
                src="\assets\alldetailpages\chainers\info\team\hrvoje.png"
                alt="img"
                className="img-fluid"
                style={{ objectPosition: "50%" }}
              />
              <h6 className="mb-0">Hrvoje Mitic </h6>
              <h5>Business Development (Gamesco.)</h5>
            </div>
            <div className="single-team">
              <img
                src="\assets\alldetailpages\chainers\info\team\4.png"
                alt="img"
                className="img-fluid"
                style={{ objectPosition: "50%" }}
              />
              <h6 className="mb-0">Dmytro Khudiiash </h6>
              <h5>Game Developer (Evoplay, Undertone)</h5>
            </div>
          </div>
        </div>
      </section>


    </>
  );
};

export default Information;